/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_How_TitleInputs */

const en_us2_exercise_sheet_how_title = /** @type {(inputs: Exercise_Sheet_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How to log`)
};

const pt_br2_exercise_sheet_how_title = /** @type {(inputs: Exercise_Sheet_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como registrar`)
};

const es_419_exercise_sheet_how_title = /** @type {(inputs: Exercise_Sheet_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cómo registrar`)
};

const pt_pt2_exercise_sheet_how_title = /** @type {(inputs: Exercise_Sheet_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como registar`)
};

const fr_fr2_exercise_sheet_how_title = /** @type {(inputs: Exercise_Sheet_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment noter`)
};

const de_de2_exercise_sheet_how_title = /** @type {(inputs: Exercise_Sheet_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`So trägst du ein`)
};

const it_it2_exercise_sheet_how_title = /** @type {(inputs: Exercise_Sheet_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come registrare`)
};

/**
* | output |
* | --- |
* | "How to log" |
*
* @param {Exercise_Sheet_How_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_how_title = /** @type {((inputs?: Exercise_Sheet_How_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_How_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_how_title(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_how_title(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_how_title(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_how_title(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_how_title(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_how_title(inputs)
	return en_us2_exercise_sheet_how_title(inputs)
});
export { exercise_sheet_how_title as "exercise-sheet.how_title" }